import { HistoryLog } from '@/interfaces/historyLog';
import { EntityResource } from './entity.resource';

/**
 * Resource historii
 *
 * @export
 * @class HistoryLogResource
 * @extends {EntityResource<HistoryLog>}
 */
export class HistoryLogResource extends EntityResource<HistoryLog> {
  public listVariables = { filters: 'HistoryFilters' };

  public getFields = {
    id: true,
    tableName: true
  };

  public listFields = {
    id: true,
    created: true,
    tableName: true,
    userId: true,
    entityId: true,
    action: true,
    changes: true,
    json: true,
    value: true,
    comment: true,
    profile: {
      id: true,
      firstName: true,
      lastName: true
    }
  };

  constructor() {
    super({
      entityName: 'historyLog'
    });
  }
}

export const historyLogResource = new HistoryLogResource();
